enum eSendingMode {
  NONE = 'none', // Used to be null, but null is not a valid enum value
  EMAIL = 'email',
  TEXT = 'text',
  EMAIL_AND_TEXT = 'email_and_text'
}

export default eSendingMode
